export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8603.b3da62bd.jpg";